/* Lockstone Emerald Rewards | Vanilla JS | no interference with native theme cart */
(() => {
  'use strict';
  if (window.__lsrInit) return;
  window.__lsrInit = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const TIER_1 = 100000, TIER_2 = 200000; // USD cents
  const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format((Number(cents)||0)/100);
  const tier = cents => cents >= TIER_2 ? 20 : cents >= TIER_1 ? 15 : 10;
  const safeJSON = el => { try { return JSON.parse(el.textContent); } catch (_) {return [];} };
  const set = (el, text) => { if(el) el.textContent = text; };

  function currentVariant(widget, variants) {
    // Horizon and most OS2 themes keep the selected variant in product form's id field.
    const section = widget.closest('.shopify-section') || document;
    const forms = [...section.querySelectorAll('form[action*="/cart/add"]')];
    const form = forms.find(f => f.querySelector('[name="id"]'));
    const idFromForm = form && form.querySelector('[name="id"]')?.value;
    const urlId = new URLSearchParams(location.search).get('variant');
    const candidate = idFromForm || urlId || widget.dataset.initialVariant;
    return variants.find(v => String(v.id) === String(candidate)) || variants.find(v=>v.available) || variants[0];
  }
  function currentQuantity(widget) {
    const section = widget.closest('.shopify-section') || document;
    const form = [...section.querySelectorAll('form[action*="/cart/add"]')].find(f=>f.querySelector('[name="quantity"]'));
    const input = form?.querySelector('[name="quantity"]') || section.querySelector('input[name="quantity"]');
    return Math.max(1, Math.min(100, parseInt(input?.value || '1',10) || 1));
  }
  function paintProduct(w) {
    const variants = safeJSON(w.querySelector('[data-lsr-variants]'));
    const v = currentVariant(w, variants);
    if(!v) return;
    const q = currentQuantity(w);
    const price = Number(v.price) * q;
    if(!Number.isFinite(price)) return;
    const percentage = tier(price);
    w.querySelectorAll('[data-lsr-tier]').forEach(el=>el.classList.toggle('is-active',Number(el.dataset.lsrTier)===percentage));
    set(w.querySelector('[data-lsr-product-savings]'), `${money(Math.round(price*percentage/100))} · ${percentage}%`);
    const next = price < TIER_1 ? TIER_1 : price < TIER_2 ? TIER_2 : 0;
    set(w.querySelector('[data-lsr-product-next]'),next ? `Add ${money(next-price)} in eligible jewelry to reach ${next===TIER_1?15:20}% savings.` : 'This selection reaches the highest 20% reward tier.');
  }
  function refreshProducts(){document.querySelectorAll('[data-lsr-product]').forEach(paintProduct);}
  let lastCart = null, inFlight = false, cartTimer;
  const widgets = () => [...document.querySelectorAll('[data-lsr-cart]')];
  function paintCart(w, cart){
    // items_subtotal_price is the item total after item-level discounts, before cart-level discounts.
    // Merchant's promotions apply to eligible merchandise: exclude gift cards if present.
    const items = cart.items || [];
    const eligible = items.reduce((sum,item)=> sum + (item.gift_card ? 0 : Number(item.final_line_price || 0)),0);
    const pct = tier(eligible);
    const next = eligible < TIER_1 ? TIER_1 : eligible < TIER_2 ? TIER_2 : 0;
    const message = items.length === 0 ? 'Your rewards begin with your first diamond.' : next ? `You have unlocked ${pct}%. Add ${money(next-eligible)} more to reach ${next===TIER_1?15:20}% OFF.` : 'You have reached our highest 20% reward tier.';
    set(w.querySelector('[data-lsr-message]'), message);
    set(w.querySelector('[data-lsr-subtotal]'),money(eligible));
    const savings = Number(cart.total_discount || 0);
    set(w.querySelector('[data-lsr-applied]'), savings>0 ? `−${money(savings)}` : 'Shown at checkout');
    set(w.querySelector('[data-lsr-discount-label]'), 'Total applied discounts');
    set(w.querySelector('[data-lsr-notice]'), savings > 0 ? 'Savings shown above are reported by Shopify and can include other eligible discounts.' : 'If no savings appear in cart, your qualifying automatic offer may be applied at checkout.');
    const meter=w.querySelector('[data-lsr-meter]');
    if(meter) meter.setAttribute('aria-valuenow',String(Math.min(2000,Math.round(eligible/100))));
    const fill=w.querySelector('[data-lsr-fill]');
    if(fill) fill.style.width = `${Math.min(100,eligible/TIER_2*100)}%`;
  }
  async function refreshCart(){
    if(!widgets().length || inFlight) return;
    inFlight=true;
    try {
      const res = await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!res.ok) throw new Error('Cart API failed');
      const cart=await res.json();
      lastCart=cart;
      if(cart.currency !== 'USD'){
        widgets().forEach(w=>w.hidden=true);
        return;
      }
      widgets().forEach(w=>{w.hidden=false;paintCart(w,cart);});
    }catch(err){console.warn('[Lockstone Rewards] Could not refresh:',err);}
    finally{inFlight=false;}
  }
  function queueCart(ms=220){clearTimeout(cartTimer);cartTimer=setTimeout(refreshCart,ms);}
  function sync(){refreshProducts();if(lastCart) widgets().forEach(w=>paintCart(w,lastCart));else queueCart(10);}
  // Typical Horizon variant picker, quantity picker and web component updates.
  document.addEventListener('change',e=>{if(e.target.closest('form[action*="/cart/add"],variant-picker,quantity-selector'))setTimeout(refreshProducts,70);if(e.target.closest('cart-items,cart-drawer,cart-drawer-component,form[action*="/cart"]'))queueCart(450);},true);
  document.addEventListener('input',e=>{if(e.target.matches('[name="quantity"],[name="id"]'))setTimeout(refreshProducts,90);},true);
  document.addEventListener('click',e=>{if(e.target.closest('[name="plus"],[name="minus"],.quantity__button'))setTimeout(refreshProducts,150);if(e.target.closest('button[name="add"],button[type="submit"],cart-drawer,cart-drawer-component,.quantity__button,[data-cart-update]'))queueCart(650);},true);
  ['cart:updated','cart:refresh','cart:change','cart:changed','variant:change','product:variant-change','shopify:section:load'].forEach(evt=>document.addEventListener(evt,()=>{refreshProducts();queueCart(150);}));
  window.addEventListener('popstate',refreshProducts);
  // Native Horizon can replace entire blocks / drawer content after AJAX operations.
  const obs = new MutationObserver(records=>{
    if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1 && (n.matches?.('[data-lsr-cart],[data-lsr-product],cart-drawer,cart-drawer-component') || n.querySelector?.('[data-lsr-cart],[data-lsr-product]'))))) sync();
  });
  function start(){
    refreshProducts();refreshCart();
    obs.observe(document.body,{childList:true,subtree:true});
    // Passive synchronization for non-standard theme/cart apps; no AJAX changes or interception.
    setInterval(()=>{if(!document.hidden && widgets().length)refreshCart();},5000);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
